import { REACT_APP_LANGUAGE } from '../../envVars';
import { AxiosUtilsType, axiosGet, axiosPost } from './axiosUtils';
import './axiosInterceptor';

export const ContentStackService = {
  async getContentStackDataConfig(): AxiosUtilsType {
    return await axiosGet(`config/data/${REACT_APP_LANGUAGE}`);
  },
};

export const ContentStackConsentService = {
  async getContentStackDataConsent(): AxiosUtilsType {
    return await axiosGet(`config/consent/${REACT_APP_LANGUAGE}`);
  },
};

export const ContentStackArticleService = {
  async getArticleByCategoryId(numberOfItem: number, categoryId?: string, subCategoryId?: string): AxiosUtilsType {
    return await axiosPost(`config/article`, { REACT_APP_LANGUAGE, numberOfItem, categoryId, subCategoryId });
  },
};
